import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function RecruiterScreeningCallMeNowConfirmationContent() {
  return (
    <Stack spacing={8} alignItems="center">
      <Illustration type="phone" />
      <Text variant="h2" align="center">
        Speak to you soon!
      </Text>
      <Stack alignItems="center" spacing={2}>
        <Text variant="body1">We&apos;ll call you in:</Text>
        <Text variant="body1" sx={{ fontWeight: 600 }}>
          15 minutes or less
        </Text>
      </Stack>
    </Stack>
  );
}
